import { render, staticRenderFns } from "./page-dutyfeedback-popup.vue?vue&type=template&id=420d1c1a&scoped=true&"
import script from "./page-dutyfeedback-popup.vue?vue&type=script&lang=js&"
export * from "./page-dutyfeedback-popup.vue?vue&type=script&lang=js&"
import style0 from "./page-dutyfeedback-popup.vue?vue&type=style&index=0&id=420d1c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d1c1a",
  null
  
)

component.options.__file = "page-dutyfeedback-popup.vue"
export default component.exports